import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Chat from './pages/chat';
import './App.css';
import Voice from './pages/voice';
import ChatX from './pages/chat-x';

function App() {
  return (
    <Router basename={`${process.env.PUBLIC_URL}`}>
      <div className="App">
        <Routes>
          <Route path="/" element={<ChatX />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/voice" element={<Voice />} />
          <Route path="/chat-x" element={<ChatX />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
